import React from 'react';
import styled from 'styled-components';
import calorieTracking from '../images/calorie-tracking.png';
import takePhoto from '../images/take-photo.png';
import reachGoals from '../images/reach-goals.png';
import foodPower from '../images/food-power.png';
import describeMeal from '../images/describe-meal.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectCoverflow } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import { SectionContainer } from './shared/SectionComponents';

const ShowcaseSection = styled(SectionContainer)`
  position: relative;
  overflow: hidden;
  padding: 1rem 0;
  background: ${({ theme }) => theme.showcaseBg};
`;

const ShowcaseSwiper = styled(Swiper)`
  width: 100%;
  padding: 1rem 0;
  
  .swiper-slide {
    transition: all 0.5s ease;
    opacity: 0.7;
    transform: scale(0.85);
  }
  
  .swiper-slide-active {
    opacity: 1;
    transform: scale(1);
    transition: all 0.5s ease;
  }
  
  .swiper-slide-prev,
  .swiper-slide-next {
    opacity: 0.85;
    transform: scale(0.85);
    transition: all 0.5s ease;
  }
  
  .swiper-button-next,
  .swiper-button-prev {
    color: ${({ theme }) => theme.primary};
    
    &:after {
      display: none;
    }
  }
  
  .swiper-pagination {
    bottom: 10px !important;
    position: relative !important;
    margin-top: 20px;
  }
  
  .swiper-pagination-bullet {
    background: var(--primary);
  }
  
  .swiper-pagination-bullet-active {
    background: var(--primary);
  }
`;

const ScreenshotContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 1rem;
`;

const Screenshot = styled.img`
  max-width: 90%;
  height: auto;
  max-height: 90%;
  border-radius: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  object-fit: contain;
`;

const Showcase = () => {
  
  const appScreens = [
    calorieTracking, 
    takePhoto, 
    reachGoals, 
    foodPower, 
    describeMeal
  ];

  return (
    <ShowcaseSection id="showcase">
      <ShowcaseSwiper
        modules={[Pagination, Autoplay, EffectCoverflow]}
        spaceBetween={1}
        slidesPerView="auto"
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        effect="coverflow"
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 1.5,
          slideShadows: false,
        }}
        pagination={{
          clickable: true,
          el: '.swiper-pagination',
        }}
        style={{ 
          "--swiper-pagination-bottom": "0px"
        }}
        breakpoints={{
          320: {
            slidesPerView: 1.2,
            spaceBetween: 1,
          },
          640: {
            slidesPerView: 1.5,
            spaceBetween: 1,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 1,
          },
          992: {
            slidesPerView: 2.5,
            spaceBetween: 1,
          }
        }}
      >
        {appScreens.map((screen, index) => (
          <SwiperSlide key={index}>
            <ScreenshotContainer>
              <Screenshot 
                src={screen} 
                alt={`1Cal app screenshot ${index+1}`} 
              />
            </ScreenshotContainer>
          </SwiperSlide>
        ))}
      </ShowcaseSwiper>
    </ShowcaseSection>
  );
};

export default Showcase; 